module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "TTe.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CT",
    attrs: {
      "id": "toc_marker-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "Introduction"
    }
  }, [_vm._v("Introduction")])]), _c('a', {
    attrs: {
      "id": "Introduction"
    }
  }, [_c('p', {
    staticClass: "SUBTITLE"
  }), _c('p', {
    staticClass: "TXF"
  }, [_vm._v("“What happens after we die?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("This is one of the great questions of human existence. Like that other great question—“Why are we here?”—it has no single accepted answer.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("For many, the survival (or rebirth) of the individual is a deeply held matter of religious faith. For others, the notion of an immortal soul is nonsense. The wisest religious and scientific thinkers agree that they may never find mutually satisfactory answers to such questions. Faith either makes sense or it does not, depending on one’s disposition, and science has little to say one way or the other with any great confidence.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Is there any way out of this impasse?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', [_vm._v("When considering this question, it is important to note that many millions of people, from the beginning of recorded history, have reported significant experiences that gave them reason to believe in the survival of the individual after death. Departed souls have contacted the living, have been seen and heard, and have given reports on their condition. Persons on the brink of death (or beyond) have returned with information on what they saw and experienced. “Past lives” have been recalled, and sometimes verified with astonishing accuracy.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("FATE")]), _vm._v(" magazine was founded in 1948 to provide a forum for extraordinary experiences of all kinds. (The first issue featured Kenneth Arnold’s report on his “flying saucer” sighting of the previous year—the sighting that marked the beginning of the UFO era.) Contributions from readers have always featured prominently in the magazine’s content, beginning in the earliest days with a section called “True Mystic Experiences.” In 1954, the editors introduced “My Proof of Survival,” a department dedicated to reader’s reports bearing on the subject of life after death.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', [_vm._v("In the forty-nine years since its debut, ")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v("FATE")]), _c('span', [_vm._v(" has published more than two thousand stories of this nature, all attested to be true by their authors. The ")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v("FATE")]), _c('span', [_vm._v(" archives represent a tremendous resource for anyone interested in the question of afterlife survival—whether looking for evidence, or simply curious about what people believe and why.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Some of the best stories from our archives are presented in this book.")])]), _c('p', {
    staticClass: "TX para-style-override-2"
  }, [_c('a', {
    attrs: {
      "id": "Introduction"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Contents#x-contents-"
    }
  }, [_c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("[contents]")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a42a15c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TTe.vue
// module id = 66
// module chunks = 0